module.exports = __webpack_public_path__ + "media/139.e167410f.wav";